<template>
    <div class="sign-up">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h2 class="headline">100% gratis, så længe du har lyst</h2>

                    <p>
                        Prøv OP'N i dag - og få fuld indsigt,
                        så du kan tage næste træk for din virksomhed
                    </p>
                </div>
            </div>

            <div class="row justify-content-center controls">
                <div class="col-lg-4">
                    <div class="form-group">
                        <input type="text" class="form-control form-control-lg" placeholder="Din e-mail" v-model="email" :class="{'is-invalid': emailError}" @keydown.enter="create">
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <input type="text" class="form-control form-control-lg" placeholder="Din hjemmeside" v-model="domain" :class="{'is-invalid': domainError}" @keydown.enter="create">
                    </div>
                </div>

                <div class="col-lg-2">
                    <div class="form-group">
                        <button class="btn btn btn-outline-light btn-lg col-sm-auto col-sm-auto lead-trigger" @click="create">
                            Kom igang
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .sign-up {
        width: 100%;
        padding: 80px 0;
        color: #fff;
        background-image: url("/static/images/pinkBg.jpg") ;

        background-position: center;


        .headline {
            padding: 0;
            margin: 0;
        }

        p {
            font-weight: 200;
            font-size: 20px;
            margin: 10px 0 50px 0;
        }

        .controls {
            input, button {
                padding: 15px 20px;
                font-size: 15px;
                box-shadow: 0 0 10px rgba(0,0,0,0.05), 0 2px 20px rgba(0,0,0,0.10);
            }

            button {
                width: 100%;
                padding: 13px 25px;
            }
        }

        button {
            cursor: pointer;
            border: 2px solid #fff;
            margin-top: -1px;

            &:hover {
                background-color: transparent;
            }
        }
    }
</style>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                email: null,
                domain: null,
                emailError: false,
                domainError: false
            }
        },

        computed: mapGetters({
            source: 'getSource'
        }),

        methods: {
            create() {
                this.emailError = (this.email === null)
                this.domainError = (this.domain === null)

                if (!this.email || !this.domain) {
                    return
                }

                let url = 'https://app.spotonlive.dk/sign-up?'

                url += 'email=' + encodeURIComponent(this.email) + '&'

                if (this.source) {
                    url += 'utm_source=' + encodeURIComponent(this.source) + '&'
                }

                url += 'domain=' + encodeURIComponent(this.domain)

                window.location.href = url
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue